import { defineStore, acceptHMRUpdate } from "pinia";
import { nasna } from "../http-common.js";

export const useAuthStore = defineStore("auth", {
  state: () => {
    return {
      isLoggedin: Boolean, // check user status
      user: JSON.parse(localStorage.getItem("user")), // user data to be stored
      token: "",
      phone: "",
      landingPageLanguage: window.localStorage.getItem("landingpage") ?? "ar", //setting default lang ar
    };
  }, // end of state
  getters: {
    getUser: (state) => state.user,
    isAuthenticated: (state) => state.user != undefined,
    getPhone: (state) => state.phone,
    getLandingPageLanguage: (state) => state.landingPageLanguage,
  }, //end of getters
  actions: {
    /**
     *
     * subscribe
     */
    async subscribeAction(phone, subscriptionPackage, referenceUserId) {
      window.localStorage.setItem("msisdn", phone);
      const payload = {
        msisdn: phone,
        subscriptionPackage: subscriptionPackage,
      };
      if (referenceUserId) {
        payload.referenceUserId = referenceUserId;
      }
      return new Promise((resolve) => {
        nasna
          .post("/auth/ksa/mobily/otp", payload)
          .then(async (response) => {
          
            resolve(response);
          })
          .catch((error) => {
            console.error("Error during subscription action:", error);
          });
      });
    },
    /**
     * verify otp
     * @param phone 
     * @param code
     * @returns {Promise} A promise that resolves with the response from the server
     * @description
     * This function verifies the OTP code for the given phone number.
     * It retrieves the phone number from local storage if not provided.
     * It sends a POST request to the server with the phone number and OTP code.
     * If the request is successful, it sets the user data in local storage.
     */
    async verifyOtp(phone, code) {
      const phoneNumber = phone || window.localStorage.getItem("msisdn");
      const AntiFrauduniqid = window.localStorage.getItem("AntiFrauduniqid");
      return new Promise((resolve) => {
        nasna
          .post("/auth/ksa/mobily/otp/verify", {
            msisdn: phoneNumber,
            otp: code,
            AntiFrauduniqid: AntiFrauduniqid,
            subscriptionPackage: window.localStorage.getItem("selectedPrice")
          })
         
          .then(async (response) => (await this.setData(response), resolve(response)));
      });
    },

    /**
     *Fetch evina script tag
     * This function fetches the evina script tag for the subscription
     *  @returns {Promise} A promise that resolves with the response from the server
     * @description
     * This function retrieves the package ID from local storage and sends a POST request to the server
     * with the package ID in the request body.
     */

    async antifraudScriptTagAction() {
      return new Promise((resolve) => {
        nasna
          .get(`/auth/ksa/mobily/antifraud?subscriptionPackage=${window.localStorage.getItem("selectedPrice")}`)
          .then(async (response) => resolve(response));
      });
    },

    /**
     * checking user subscribtion status
     * @param phone
     * http://api.nasna.tv/api/auth/login_by_msisdn
     */
    async checkSubescriptionStatus(phone) {
     
      return new Promise((resolve) => {
        nasna
          .post("/auth/login_by_msisdn", {
            msisdn: phone,
              issue_token : true

          })
          .then(async (response) => {
            await this.setData(response);
            resolve(response);
          });
      });
      
    },
    async setData(response) {
      if (response.data.success) {
        window.localStorage.setItem("token", response.data.token);
        window.localStorage.setItem("isActive", response.data.token ? true : false);
        window.localStorage.setItem("user", JSON.stringify(response.data.user));
      } else {
        this.wipeUserData(response);
      }
    },

    async unsubscribe() {
      var phone = null;
      const usre = JSON.parse(window.localStorage.getItem("user"));
      if (usre && usre.phone) {
        phone = usre.phone;
      }

      if (phone != null) {
        return new Promise((resolve) => {
          nasna
            .post("/auth/ksa/mobily/unsub", {
              msisdn: phone,
            })
            .then((response) => (this.wipeUserData(response), resolve(response)));
        });
      }
    },

    wipeUserData(response) {
      if (response.data.success == true) {
        window.localStorage.removeItem("token"),
          window.localStorage.removeItem("isActive");
      }
    },

    async login(phone) {
      await nasna
        .post(`login/subscribe_ok?msisdn=/${phone}`)
        .then(async (response) => console.log(response));
    },

    async changeLanguage() {
      if (this.landingPageLanguage == "en") {
        this.landingPageLanguage = "ar";
        window.localStorage.setItem("landingpage", this.landingPageLanguage);
      } else if (this.landingPageLanguage == "ar") {
        this.landingPageLanguage = "en";
        window.localStorage.setItem("landingpage", this.landingPageLanguage);
      } else {
        this.landingPageLanguage = "en";
        window.localStorage.setItem("landingpage", this.landingPageLanguage);
      }

      return this.landingPageLanguage;
    },
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
